import React from 'react';
import { Container } from 'react-bootstrap';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Soon = () => {
    const testError = true; // set true to test

    if (testError) {
        throw new Error("Test Error!");
    }
    return (
        <>
            <Container style={{ width: "100vw", height: '90vh' }} className='d-flex justify-content-center align-items-center'>
                <DotLottieReact
                    src="https://lottie.host/c2052b7f-1f4a-44f3-8b63-87929e35ca5e/9hM4ElcVIC.lottie"
                    loop
                    autoplay
                />
            </Container>
        </>
    );
}

export default Soon;
